export const MACRO_FOLDER_NAMES = {
  'macro-ctv': 'Macro CTV'
} as const;
